import { authHeader, handleResponse } from "../utils/utils";
import { API_BASE } from "../config/constants";

const uploadArtwork = async (id, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader() },
        body: data
    };

    let response ;
    if (id == '0'){
        response = fetch(`${API_BASE}/artwork/${id}/addArtworkByArtist`, requestOptions);
    }
    else
        response = fetch(`${API_BASE}/artwork/${id}`, requestOptions);
    return await handleResponse(response);
}

const uploadBillDoc = async (id, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader() },
        body: data
    };

    const response = fetch(`${API_BASE}/purchase/${id}`, requestOptions)
    return await handleResponse(response);
}

const updateMIA = async (id, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader() },
        body: data
    };

    const response = fetch(`${API_BASE}/artwork/${id}/mia`, requestOptions)
    return await handleResponse(response);
}

const updateSold = async (id, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader() },
        body: data
    };

    const response = fetch(`${API_BASE}/artwork/${id}/sold`, requestOptions)
    return await handleResponse(response);
}

const updateStolen = async (id, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader() },
        body: data
    };

    const response = fetch(`${API_BASE}/artwork/${id}/stolen`, requestOptions)
    return await handleResponse(response);
}

const updatePolice = async (id, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader() },
        body: data
    };

    const response = fetch(`${API_BASE}/artwork/${id}/police`, requestOptions)
    return await handleResponse(response);
}

const updateInsurance = async (id, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader() },
        body: data
    };

    const response = fetch(`${API_BASE}/artwork/${id}/insurance`, requestOptions)
    return await handleResponse(response);
}

const votePurchase = async (id) => {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };

    const response = fetch(`${API_BASE}/purchase/${id}`, requestOptions)
    return await handleResponse(response);
}

const voteArtist = async (id) => {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id
        })
    };

    const response = fetch(`${API_BASE}/users/vote`, requestOptions)
    return await handleResponse(response);
}

const disvoteArtist = async (id) => {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id
        })
    };

    const response = fetch(`${API_BASE}/users/disvote`, requestOptions)
    return await handleResponse(response);
}

const toggleArtist = async (id) => {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id
        })
    };

    const response = fetch(`${API_BASE}/users/toggle_recommend`, requestOptions)
    return await handleResponse(response);
}

const reportArtist = async (id, message) => {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id,
            message
        })
    };

    const response = fetch(`${API_BASE}/users/report`, requestOptions)
    return await handleResponse(response);
}

const changeCheckPurchase = async (id, status) => {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id,
            status
        })
    };

    const response = fetch(`${API_BASE}/users/check_purchase`, requestOptions)
    return await handleResponse(response);
}

const changeAdmin = async (id, status) => {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id,
            status
        })
    };

    const response = fetch(`${API_BASE}/users/change_admin`, requestOptions)
    return await handleResponse(response);
}

const changeSalePrice = async (id, price) => {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id,
            price
        })
    };

    const response = fetch(`${API_BASE}/artwork/change_saleprice`, requestOptions)
    return await handleResponse(response);
}

const sendReviewArtwork = async (id, status) => {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            status
        })
    };

    const response = fetch(`${API_BASE}/artwork/${id}`, requestOptions)
    return await handleResponse(response);
}

const deleteArtwork = async (id) => {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    const response = fetch(`${API_BASE}/artwork/${id}/delete`, requestOptions)
    return await handleResponse(response);
}

const getArtwork = async (id) => {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };

    const response = fetch(`${API_BASE}/artwork/${id}`, requestOptions)
    return await handleResponse(response);
}

const getArtworks = async (type, filterkey='', order=false, pagesize=20, pagefrom=0) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            type,
            filterkey,
            order,
            pagesize,
            pagefrom
        })
    };

    const response = fetch(`${API_BASE}/artwork`, requestOptions)
    return await handleResponse(response);
}

const getNormalData = async (filter) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    const response = fetch(`${API_BASE}/search/normal/${filter}`, requestOptions)
    return await handleResponse(response);
}

const getPurchase = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };

    const response = fetch(`${API_BASE}/purchase`, requestOptions)
    return await handleResponse(response);
}

const getUsers = async (type, options, filterkey='', order=false, pagesize=20, pagefrom=0) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            type,
            options,
            filterkey,
            order,
            pagesize,
            pagefrom
        })
    };

    const response = fetch(`${API_BASE}/users`, requestOptions)
    return await handleResponse(response);
}

const verifyArtwork = async (id, options = {}) => {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id,
            superadmin_override: options.superadminOverride === true,
        })
    };

    const response = fetch(`${API_BASE}/artwork`, requestOptions)
    return await handleResponse(response);
}

const disvoteArtwork = async (id) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id
        })
    };

    const response = fetch(`${API_BASE}/artwork/disvote`, requestOptions)
    return await handleResponse(response);
}

const toggleRecommend = async (id) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id
        })
    };

    const response = fetch(`${API_BASE}/artwork/toggle_recommend`, requestOptions)
    return await handleResponse(response);
}

const toggleCarousel = async (id) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id
        })
    };

    const response = fetch(`${API_BASE}/artwork/toggle_carousel`, requestOptions)
    return await handleResponse(response);
}

const reportArtwork = async (id, message) => {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id,
            message
        })
    };

    const response = fetch(`${API_BASE}/artwork/disvote`, requestOptions)
    return await handleResponse(response);
}

//very strange
// const getArtworkPriceAnalysis = async() => {
//     const requestOptions = {
//         method: 'GET',
//         headers: { ...authHeader(), 'Content-Type': 'application/json' },
//     };
//     const response = fetch(`${API_BASE}/artwork/getArtworkPriceAnalysis`, requestOptions);
    
//     console.log("URL", `${API_BASE}/artwork/getArtworkPriceAnalysis`);
//     return await handleResponse(response);
// }


const getSettings = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() },
    };
    const response = fetch(`${API_BASE}/settings`, requestOptions);
    return await handleResponse(response);
};

const saveSetting = async (name, value) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, value }),
    };
    const response = fetch(`${API_BASE}/settings`, requestOptions);
    return await handleResponse(response);
};

const deleteSetting = async (name) => {
    const requestOptions = {
        method: 'DELETE',
        headers: { ...authHeader() },
    };
    const response = fetch(`${API_BASE}/settings/${encodeURIComponent(name)}`, requestOptions);
    return await handleResponse(response);
};

const getSiteSettings = async () => {
    const response = fetch(`${API_BASE}/settings/site`, { headers: { ...authHeader() } });
    return await handleResponse(response);
};

const saveSiteSettings = async (settings) => {
    const response = fetch(`${API_BASE}/settings/site`, {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(settings),
    });
    return await handleResponse(response);
};

const getMarketingConfig = async () => {
    const response = fetch(`${API_BASE}/settings/marketing/config`, { headers: { ...authHeader() } });
    return await handleResponse(response);
};

const saveMarketingConfig = async (config) => {
    const response = fetch(`${API_BASE}/settings/marketing/config`, {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(config),
    });
    return await handleResponse(response);
};

const getEmailTemplates = async () => {
    const response = fetch(`${API_BASE}/settings/email-templates`, { headers: { ...authHeader() } });
    return await handleResponse(response);
};

const saveEmailTemplate = async (template) => {
    const response = fetch(`${API_BASE}/settings/email-templates`, {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(template),
    });
    return await handleResponse(response);
};

const sendBroadcast = async (payload) => {
    const response = fetch(`${API_BASE}/settings/broadcast`, {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    return await handleResponse(response);
};

const getAnalyticsSummary = async () => {
    const response = fetch(`${API_BASE}/settings/analytics`, { headers: { ...authHeader() } });
    return await handleResponse(response);
};

const getPublicTracking = async () => {
    const response = fetch(`${API_BASE}/settings/tracking/public`);
    return await handleResponse(response);
};

const getPublicBanner = async () => {
    const response = fetch(`${API_BASE}/settings/banner/public`);
    return await handleResponse(response);
};

const getBannerConfig = async () => {
    const response = fetch(`${API_BASE}/settings/banner`, { headers: { ...authHeader() } });
    return await handleResponse(response);
};

const saveBannerConfig = async (banner) => {
    const response = fetch(`${API_BASE}/settings/banner`, {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(banner),
    });
    return await handleResponse(response);
};

const getTrackingConfig = async () => {
    const response = fetch(`${API_BASE}/settings/tracking`, { headers: { ...authHeader() } });
    return await handleResponse(response);
};

const saveTrackingConfig = async (tracking) => {
    const response = fetch(`${API_BASE}/settings/tracking`, {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(tracking),
    });
    return await handleResponse(response);
};

const getAnalyticsDashboard = async (category = 'overview') => {
    const response = fetch(
        `${API_BASE}/settings/analytics/dashboard?category=${encodeURIComponent(category)}`,
        { headers: { ...authHeader() } }
    );
    return await handleResponse(response);
};

const getAnalyticsCommits = async () => {
    const response = fetch(`${API_BASE}/settings/analytics/commits`, { headers: { ...authHeader() } });
    return await handleResponse(response);
};

const getContactLists = async (q = '') => {
    const qs = q ? `?q=${encodeURIComponent(q)}` : '';
    const response = fetch(`${API_BASE}/settings/contact-lists${qs}`, { headers: { ...authHeader() } });
    return await handleResponse(response);
};

const createContactList = async (payload) => {
    const response = fetch(`${API_BASE}/settings/contact-lists`, {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    return await handleResponse(response);
};

const updateContactList = async (id, payload) => {
    const response = fetch(`${API_BASE}/settings/contact-lists/${id}`, {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    return await handleResponse(response);
};

const deleteContactList = async (id) => {
    const response = fetch(`${API_BASE}/settings/contact-lists/${id}`, {
        method: 'DELETE',
        headers: { ...authHeader() },
    });
    return await handleResponse(response);
};

const importContacts = async (listId, contacts) => {
    const response = fetch(`${API_BASE}/settings/contact-lists/import`, {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ list_id: listId, contacts }),
    });
    return await handleResponse(response);
};

export const artService = {
    uploadArtwork,
    getArtwork,
    getArtworks,
    verifyArtwork,
    disvoteArtwork,
    reportArtwork,
    sendReviewArtwork,
    uploadBillDoc,
    getPurchase,
    votePurchase,
    getUsers,
    voteArtist,
    disvoteArtist,
    reportArtist,
    changeCheckPurchase,
    changeAdmin,
    changeSalePrice,
    getNormalData,
    toggleRecommend,
    toggleArtist,
    deleteArtwork,
    toggleCarousel,
    updateMIA,
    updateSold,
    updateStolen,
    updatePolice,
    updateInsurance,
    getSettings,
    saveSetting,
    deleteSetting,
    getSiteSettings,
    saveSiteSettings,
    getMarketingConfig,
    saveMarketingConfig,
    getEmailTemplates,
    saveEmailTemplate,
    sendBroadcast,
    getAnalyticsSummary,
    getPublicTracking,
    getPublicBanner,
    getBannerConfig,
    saveBannerConfig,
    getTrackingConfig,
    saveTrackingConfig,
    getAnalyticsDashboard,
    getAnalyticsCommits,
    getContactLists,
    createContactList,
    updateContactList,
    deleteContactList,
    importContacts,
};
